import { applySnapshot, getSnapshot, types } from 'mobx-state-tree'
import { fromPromise } from 'mobx-utils'
import { apiV1 } from '../../utils'
import { when } from 'mobx'

// модель роли
const AppRoleModel = types.model('AppRoleModel', {
  id: types.identifierNumber,
  roleName: types.string,
  description: types.maybeNull(types.string),
})

const AppRoleStore = types
  .model('AppRoleStore')
  .props({
    _data: types.optional(types.array(AppRoleModel), []),
    _isPending: types.optional(types.boolean, false),
  })
  .actions(self => {
    const API_URL = '/AppRoles'

    const setRoles = roles => {
      applySnapshot(self._data, roles)
    }

    // получить список ролей
    const getRoles = () => {
      const request = fromPromise(apiV1.get(API_URL))
      when(() => {
        request.case({
          fulfilled: response => {
            setRoles(response.data)
            return true
          },
        })
      })
      return request
    }

    // создать новую роль
    const addRole = role => {
      return fromPromise(apiV1.post(API_URL, role))
    }

    // обновить роль
    const updateRole = role => {
      return fromPromise(apiV1.put(API_URL, role))
    }

    // удалить роль
    const deleteRole = id => {
      return fromPromise(apiV1.delete(`${API_URL}/${id}`))
    }

    return {
      setRoles,
      getRoles,
      addRole,
      updateRole,
      deleteRole,
    }
  })
  .views(self => ({
    get roles() {
      return getSnapshot(self._data)
    },
    get isPending() {
      return self._isPending
    },
  }))

export default AppRoleStore
